// NPM Imports
import React, { Fragment } from "react";

// Component Imports
import UserGroupRoles from "./UserGroupRoles";
import UserGroupRolesUpgrade from "./UserGroupRolesUpgrade";
import { FeatureGating } from "../../../commonComponents";

// Internal Imports
import { FEATURES } from "../../../constants";

// Destructuring
const { FEATURES_NAME } = FEATURES;

export default function (props) {
  return (
    <Fragment>
      <FeatureGating
        name={FEATURES_NAME.TEMPLATES_USERGROUPS}
        altComponent={
          <UserGroupRolesUpgrade
            {...props}
            featureName={FEATURES_NAME.TEMPLATES_USERGROUPS}
          />
        }>
        <UserGroupRoles {...props} />
      </FeatureGating>
    </Fragment>
  );
}
